import React                  from 'react'
import { Container }          from '@material-ui/core'
import PhotoSearchComponent   from '../Components/PhotoSearchComponent'

const PhotoSearch = props => {

   return (
      <Container style={{ marginTop: '5rem' }}>
         <PhotoSearchComponent buttonLabel={'Button Not Needed'} />
      </Container>
   )

}

export default PhotoSearch